import React from "react";
import Cartpage from "../Components/Cart/Cartsection.js";
import { useEffect, useState } from "react";
import ProgressTracker from "../Components/Progresstracker/ProgressTracker.js";
import SpecialProducts from "../Components/Productdetails/SpecialProducts.js";
import { fetchCartItems } from "../features/cartitemsSlice.js";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import cartnotfoundimg from "../assets/images/cart_notfound.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
function Cartscreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const user_id = localStorage.getItem("userId");
  const { items = [], grand_total } = useSelector((state) => state.cartitems);

  const [cartItems, setCartItems] = useState(items);

  useEffect(() => {
    setCartItems(items.map((item) => ({ ...item })));
  }, [items]);

  useEffect(() => {
    if (user_id) {
      dispatch(fetchCartItems(user_id));
    }
  }, [dispatch, user_id]);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigatelogin = ()=>{
    navigate('/login');
  }

  return (
    <>
      {user_id ? (
        <>

          {cartItems && cartItems.length > 0 ? (
            <>
              <ProgressTracker currentStep={1} />
              <Cartpage />
              <SpecialProducts />
            </>
          ) : (
            <section className="pt-40 pb-40 cart_notfound">
              <div className="container">
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-lg-6 col-md-8 col-sm-12">
                    <div className="inner-box">
                      <img
                        src={cartnotfoundimg}
                        style={{ width: "70%" }}
                        alt="img"
                      />
                      <h4 className="mt-5" style={{ color: "#374706" }}>
                        Your Cart is Empty
                      </h4>
                      <p className="mb-0">
                        Looks like you have not added anything to your Cart !
                      </p>
                      <div className="btn_box">
                        <Link to="/"> Go to home page</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      ) : (
        <>{navigatelogin()}</>
      )}
    </>
  );
}

export default Cartscreen;
